import 'devextreme/dist/css/dx.light.css';
import { useEffect, useState } from "react";
import { Button, Space, Spin, notification, Tooltip, Popconfirm, Table, } from 'antd';
import { DeleteFilled, EditFilled, PlusOutlined } from '@ant-design/icons'
import axios from 'axios';
import axiosConfig from '../../configs/axios.config';
import PermissionDetail from '../../components/permission/PermisionDetail';
import { useSelector } from 'react-redux';
import { AccessRolesSelector } from '../../store/reducers/permistion';
import Utils from '../../utils';
import { ACTION, MODULES } from '../../configs/namePermission';

function Permission() {
    const [pages, setPages] = useState([])
    const [loading, setLoading] = useState(false)
    const AuthSelectors = useSelector(AccessRolesSelector)
    const [open, setOpen] = useState(false)
    const [type, setType] = useState('')
    const [id, setID] = useState(0)
    const [detailData,setDetailData] = useState()

    const _getData = () => {
        const response = axios.create(axiosConfig).get('/api/groupRoles')
        setLoading(true)
        response
            .then((response) => {
                if(response.status !== 200 && !response.data) {
                    return notification.warning({
                        message: response.data.message || "Lỗi hệ thống",
                    })
                }
                const { list } = response.data.data
                setPages(list)
                setLoading(false)
            })
            .catch((error) => {
                console.log(error);
                setLoading(false)
                return notification.warning({
                    message: error || "Hệ thống đang bảo trì, vui lòng thử lại sau!",
                })
            })
    }
    useEffect(() => {
        _getData()
    }, []);
    const detailPermission = async(_id) =>{
        setLoading(true)
        const response = axios.create(axiosConfig).get(`/api/groupRoles/${_id}`)
        response
            .then((response) => {
                if(response.status !== 200 && !response.data) {
                    return notification.warning({
                        message: response.data.message || "Lấy detail thất bại vui lòng thử lại",
                    })
                }
                setDetailData(response.data.data)
                setLoading(false)
            })
            .catch((error) => {
                console.log(error);
                setLoading(false)
                return notification.warning({
                    message: error || "Hệ thống đang bảo trì, vui lòng thử lại sau!",
                })
            })
        
      }
    
    const _deletePage = (id) => {
        try {
            if(id) {}
            const response = axios.create(axiosConfig).delete(`/api/groupRoles/${id}`)
            response
                .then((response) => {
                    if(response.status !== 200 && !response.data) {
                        return notification.warning({
                            message: response.data.message || "Lỗi hệ thống",
                        })
                    }
                    _getData()
                    notification.success({ message: response.data.message || "Thành công" })
                })
                .catch((error) => {
                    console.log(error);
                    setLoading(false)
                    return notification.warning({
                        message: error || "Hệ thống đang bảo trì, vui lòng thử lại sau!",
                    })
                })
        } catch (err) {
          console.log(err)
        }
    }
    const createData = () => {
        setOpen(true)
        setType('CREATE')
    }
    const updateData = (id) => {
        detailPermission(id)
        setOpen(true)
        setType('UPDATE')
        setID(id)
    }
    

    const columns = [
    {
        title: 'STT',
        render: (text, record, index) => index + 1,
        align: 'center',
        key: 'index'
    },
    {
        title: 'Tên',
        align: 'center',
        dataIndex: 'name',
        render: (text) => text,
    },
    {
        title: 'Mô tả',
        align: 'center',
        dataIndex: 'description',
        render: (text) => text,
    },
    {
        title: 'Vai trò',
        align: 'center',
        dataIndex: 'key',
        render: (text) => text,
    },
    {
        title: 'Hành động',
        align: 'center',
        render: (text, record) => (
        <Space className="action">
            {
                Utils.checkPermistion(AuthSelectors, MODULES.PERMISSION, ACTION.UPDATE) ? 
                <Tooltip placement="top" title={'Chi tiết'}>
                <Button onClick={() => { updateData(record.id) }}>
                    <EditFilled />
                </Button>
                </Tooltip> : ''
            }
            {
                Utils.checkPermistion(AuthSelectors, MODULES.PERMISSION, ACTION.DELETE) ? 
                <Tooltip placement="top" title={'Xóa'}>
                    <Popconfirm
                        title="Bạn có muốn xóa trang này?"
                        okText="Yes"
                        cancelText="No"
                        onConfirm={() => _deletePage(record.id)}
                    >
                        <Button danger >
                        <DeleteFilled />
                        </Button>
                    </Popconfirm>
                </Tooltip> : ''
            }
        </Space>
        )
    },
    ]
    
    return (
        <>
            <div className="flex justify-between items-center">
            {
                Utils.checkPermistion(AuthSelectors, MODULES.PERMISSION, ACTION.CREATE) ? 
                <Button onClick={createData}>
                    <PlusOutlined />
                </Button> : ''
            }
            </div>
            <Spin tip="Loading..." spinning={loading}>
                <div className='mt-3'>
                    <Table
                        dataSource={pages}
                        pagination={false}
                        columns={columns}
                        className="mt-3 table-custom"
                        bordered
                        scroll={{ x: 640 }}
                        rowKey={record => record.id}
                    ></Table>
                </div>
                <div >
                    <PermissionDetail 
                    open={open} 
                    type={type} 
                    id={id} 
                    setOpen={setOpen} 
                    reloadPage={_getData}
                    detailData={detailData ? detailData : null}/>
                </div>
                
            </Spin>
            
        </>
    );
}

export default Permission;